// extracted by mini-css-extract-plugin
export default {"success":"StatusMarker-success-476cb21001e826716be0dd3884fa3227","error":"StatusMarker-error-a2a6f3d4530b1b4bc312d32fdbe3c91b"};